/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { mapRouteToRelativePath } from "../../util/routing";

export const AGREEMENTS_ROUTE_NAME = 'agreements';
export const AGREEMENTS_ROUTE = mapRouteToRelativePath(AGREEMENTS_ROUTE_NAME);
